import { DateService } from '@/coreDomainsModule/services/dateService';
import { PostOrderToOrderGroupRequest } from '@/coreInfrastructureModule/axios/generated/orderGroupManage';

/**
 * 発注グループ紐付けのリクエストに変換する
 */
export class BulkPostOrderToOrderGroupAdapter {
  /**
   * 変換する
   * @param orderGroupId - 発注グループID
   * @param orderIds - 複数の発注ID
   * @param eta - 変更する納期
   */
  public static adapt(orderGroupId: string, orderIds: string[], eta?: number): PostOrderToOrderGroupRequest {
    const postOrderToOrderGroupRequest: PostOrderToOrderGroupRequest = {
      postOrderToOrderGroupInfo: {
        estimatedTimeOfArrival: eta ? DateService.formatDateToISOString(DateService.convertUnixTimeToDate(eta / 1000)) : undefined,
        postOrderToOrderGroupOrderInfo: {
          orderGroupId,
          orderIds,
        },
      },
    };
    return postOrderToOrderGroupRequest;
  }
}
